import { window } from 'browser-monads';

export enum DEVICES {
	WindowsPhone = 'Windows Phone',
	Android = 'Android',
	IOS = 'iOS',
	Unknown = 'unknown',
}

export function getMobileDevice() {
	console.log('dummy testing');
	const userAgent = window.navigator.userAgent;

	if (/windows phone/i.test(userAgent)) {
		return DEVICES.WindowsPhone;
	}

	if (/android/i.test(userAgent)) {
		return DEVICES.Android;
	}

	if (/iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
		return DEVICES.IOS;
	}

	return DEVICES.Unknown;
}
